import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Button from '../atoms/button.jsx';
import { Label } from '../atoms/label.jsx';
import { COLOR, SIZE, FONT_FAMILY } from '../../utils/constants.js';

const ModalOverlay = styled.div`
    position: fixed;
    inset: 0;
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0px 15px;
    background-color: rgba(0, 0, 0, 0.5);
`;

const ModalCard = styled.div`
    width: 100%;
    max-width: 450px;
    padding: 25px;
    text-align: center;
    background-color: ${COLOR.background};
    border-radius: 25px;
    box-shadow: -1px 0px 22px -3px rgba(153,153,153,1);
`;

const ModalActions = styled.div`
    display: flex;
    justify-content: center;
`;

// Centered message with a single "Ok" button that closes it.
const MessageModal = ({ children, onClose }) => (
    <ModalOverlay>
        <ModalCard role='dialog' aria-modal='true'>
            <Label
                margin='0 0 20px 0'
                text_size={SIZE.subtitle}
                text_color={COLOR.ferra}
                font_family={FONT_FAMILY.avenirMedium}>
                { children }
            </Label>
            <ModalActions>
                <Button
                    type='button'
                    height='36px'
                    bg_color={ COLOR.primaryDark }
                    onClick={ onClose }>
                    <Label
                        text_color={ COLOR.white }
                        text_size={SIZE.body}
                        font_family={FONT_FAMILY.avenirMedium}
                        margin='auto'>
                        Ok
                    </Label>
                </Button>
            </ModalActions>
        </ModalCard>
    </ModalOverlay>
);

MessageModal.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func
}

export default MessageModal;
